<template>
  <div class="profile-table">
    <table>
      <thead>
        <th class="col-xs-7">{{name}}</th>
        <!--<th class="col-xs-3">Profile</th>-->
        <th class="col-xs-3" style="text-align: right">Show</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>{{item.title}}</td>
          <!--<td>{{item.profile}}</td>-->
          <td style="text-align: right">{{item.show}}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AudienceProfileTable',
  props: {
    name: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  margin: 3px auto;
  width: 100%;
}

th {
  padding: 0 3px;
  border-bottom: 1px solid #ccc;
}

td {
  padding: 2px 3px;
}
</style>




// WEBPACK FOOTER //
// AudienceProfileTable.vue?52bf414f